import { TRAILER_LEASE, TRUCK_RENTAL } from '../../../constants/tenants';
const accNumPerTenantMapper = new Map();

accNumPerTenantMapper.set(TRUCK_RENTAL, { 2: 21010, 1: 11110 });
accNumPerTenantMapper.set(TRAILER_LEASE, { 2: 21010, 1: 11110 });

export const getAccNumPerTenant = (id, key) => {
  return accNumPerTenantMapper.get(id)[`${key}`];
};
